import { axiosInstance } from "../authService";
import ApiUrlConstant from "../Constants";
import { apiKey } from "../../config/env";
const headers = { "Ocp-Apim-Subscription-Key": apiKey };

const PackageManagementService = {
  getUserManagement: (params = {}, token) => {
    const url = ApiUrlConstant.listUserManagement();
    return axiosInstance.get(url, {
      params, headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getRole: (token) => {
    return axiosInstance.get(ApiUrlConstant.getRole(), {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  addUser: (data, token) => {
    return axiosInstance.post(ApiUrlConstant.addUserService(), data, {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getUser: (id, token) => {
    return axiosInstance.get(ApiUrlConstant.getUser(id), {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  updateUser: (id, userDetails, token) => {
    return axiosInstance.put(ApiUrlConstant.updateUser(id), userDetails, {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getUserList: (params = {}, token) => {
    return axiosInstance.get(ApiUrlConstant.userListForProject(), {
      params, headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  resendEmail: (data, token) => {
    return axiosInstance.post(ApiUrlConstant.resendEmail(), data, {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAllUserList: (token) => {
    return axiosInstance.get(ApiUrlConstant.getAllUserList(), {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
    })
  },

  changePassword: (data, token) => {
    return axiosInstance.put(ApiUrlConstant.changePassword(), data, {
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`
      }
    })
  }



};

export default PackageManagementService;
